import React, { CSSProperties, MouseEventHandler } from "react";
import { orderStatusConfig } from "../../types/types";
import "./ExpiryDateCell.css";
import { Tooltip } from "@mui/material";

interface OrderStatusCellProps {
  orderStatusConfig: orderStatusConfig[];
  statusId: string;
  onClickHandler?: MouseEventHandler<HTMLDivElement>;
  solidColors?:boolean
  RenderFlagging?: React.ReactNode
  isARS?: boolean
  inCustomAccordion?: boolean
}

const OrderStatusCell: React.FC<OrderStatusCellProps> = ({ orderStatusConfig, statusId,solidColors, RenderFlagging, isARS, inCustomAccordion }) => {

  const getColorAndLabelData = (statusId: string) => {
    const statusParams = orderStatusConfig?.find((item) => {
      const statuses: string[] = item.id?.split(",") ?? [];
      return statuses.some(status => status.trim().toLowerCase() === statusId?.toLowerCase());
    });
    return {
      color: statusParams?.dmsLabelColor ?? "black",
      bgColor: statusParams?.dmsColor ?? (isARS ? "rgb(218 218 218)" : "white"),
      label: statusParams?.dmsLabel ?? (isARS ? "Not Applicable" : "Not Available"),
    };
  };

  const { color, bgColor, label } = getColorAndLabelData(statusId);

  const cellStyle: CSSProperties = {
    color: solidColors ? "#fff" : color,
    border: inCustomAccordion ? `1px solid ${color}` : "",
    borderRadius: inCustomAccordion ? "" : "20px",
    background: inCustomAccordion
      ? solidColors
        ? color 
        : bgColor 
      : `linear-gradient(to right, ${bgColor}, transparent)`,
    minWidth: inCustomAccordion ? 0 : "4.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  return (
    <Tooltip title={label} arrow>
      <div className={`ExpiryDateCell ${inCustomAccordion ? 'ExpiryDateCell--accordion' : ''}`} style={cellStyle}>
        <span style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: '1 1 auto',
          minWidth: 0,
        }}>
          {label}
        </span>
        {RenderFlagging && (
          <div style={{ flex: '0 0 auto' }}>
            {RenderFlagging}
          </div>
        )}
      </div>
    </Tooltip>
  );
};

export default OrderStatusCell;
